export default {
  list: { lazy: () => import('./hardwareDistributors'), component: 'HardwareDistributorList' },
  create: { lazy: () => import('./hardwareDistributors'), component: 'HardwareDistributorCreate' },
  edit: { lazy: () => import('./hardwareDistributors'), component: 'HardwareDistributorEdit' },
  options: {
    create: {
      breadCrumb: 'Create Global Hardware Supplier',
      title: 'Create Global Hardware Supplier',
    },
    list: {
      breadCrumb: 'Global Hardware Suppliers',
    },
    edit: {
      breadCrumb: 'Edit Global Hardware Supplier',
    },
  },
}
